import {
  EditGuesser as RAEditGuesser,
  EditGuesserProps as RAEditGuesserProps,
} from '@api-platform/admin';

export const EditGuesser = RAEditGuesser;

export type EditGuesserProps = RAEditGuesserProps;
